<template>
    <v-card light>
        <v-toolbar
            flat
            color="grey lighten-3"
            height="70"
        >
            <v-toolbar-title color="panelHeader">
                <v-layout
                    align-center
                    justify-space-between
                >
                    <span class=" primary--text">Solicitações de Pagamento de Devolução</span>
                </v-layout>
            </v-toolbar-title>
            <v-spacer />
            <v-radio-group
                v-model="status"
                row
                hide-details
            >
                <v-radio
                    label="Todas"
                    :value="0"
                />
                <v-radio
                    label="Pendentes"
                    :value="1"
                />
                <v-radio
                    label="Finalizadas"
                    :value="2"
                />
            </v-radio-group>
            <v-spacer />
            <v-btn
                text
                outlined
                color="primary"
                @click="refreshList"
            >
                <v-icon left>
                    mdi-table-sync
                </v-icon>
                Atualizar
            </v-btn>
        </v-toolbar>
        <v-data-table
            :headers="meta.headers"
            :items="items"
            :options.sync="meta.options"
            :server-items-length="meta.totalItems"
            no-data-text="Nenhum item disponível para exibição"
            no-results-text="Nenhum item disponível para exibição"
            disable-sort
            :footer-props="{ 'items-per-page-options': [10] }"
        >
            <template v-slot:item="{ item }">
                <tr>
                    <td>{{ item.ID_SOL_PAGAMENTO }}</td>
                    <td>{{ item.CNPJ }}</td>
                    <td>{{ item.RAZAO_SOCIAL }}</td>
                    <td>{{ item.CONTATO }}</td>
                    <td>{{ item.TELEFONE }}</td>
                    <td>{{ item.EMAIL }}</td>
                    <td>{{ new Date(item.UPDATED_AT).toLocaleString() }}</td>
                    <td>
                        <v-chip
                            small
                            dark
                            :color="item.ID_STATUS_SOLICITACAO === '1' ? 'red lighten-2' : 'green lighten-2'"
                        >
                            {{ item.NOME_STATUS_SOLICITACAO }}
                        </v-chip>
                    </td>
                    <td>
                        <v-btn
                            color="primary"
                            icon
                            :to="`/painel-solpagamento/${item.ID_SOL_PAGAMENTO}`"
                        >
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn
                            color="primary"
                            icon
                            @click="sendMailToUser(item.ID_SOL_PAGAMENTO)"
                        >
                            <v-icon>mdi-email-send-outline</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
                <div class="py-5">
                    Registro {{ pageStart }} à {{ pageStop }} de {{ itemsLength }}
                </div>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import api from '../../../services/api';

    export default {
        data() {
            return {
                meta: {
                    headers: [
                        { value: 'ID_SOL_PAGAMENTO', text: 'ID', width: 1 },
                        { value: 'CNPJ', text: 'CNPJ', width: 1 },
                        { value: 'RAZAO_SOCIAL', text: 'RAZÃO SOCIAL', width: 1 },
                        { value: 'CONTATO', text: 'CONTATO' },
                        { value: 'TELEFONE', text: 'TELEFONE' },
                        { value: 'EMAIL', text: 'E-MAIL' },
                        { value: 'UPDATED_AT', text: 'CRIADA/ATUALIZADA EM', width: 1 },
                        { value: 'NOME_STATUS_SOLICITACAO', text: 'STATUS', width: 1 },
                        { value: '', text: '', width: 1 }
                    ],

                    totalItems: 0,

                    options: {}
                },

                items: [],

                status: 0
            };
        },

        watch: {
            'meta.options': 'fetchItems',
            'status': 'fetchItems'
        },

        methods: {
            async fetchItems() {
                try {
                    const { page } = this.meta.options;
                    const response = await api.getSolPagamentoList(page, this.status);
                    const { data, total } = response.data;

                    this.meta.totalItems = total;
                    this.items = data;
                } catch (error) {
                    this.$root.$emit('message', { text: 'Erro ao listar os itens.', color: 'error' });
                }
            },

            refreshList() {
                if (this.status === 0) {
                    this.fetchItems();
                }

                this.status = 0;
            },

            async sendMailToUser(id) {
                try {
                    await api.sendMailSolPagamento(id);

                    this.$root.$emit('message', { text: 'E-mail enviado com sucesso!', color: 'success' });
                } catch (error) {
                    this.$root.$emit('message', { text: 'Erro ao enviar e-mail.', color: 'error' });
                }
            }
        }
    };
</script>